import React from 'react';

import { Notice } from './styles';
//import '../../../../node_modules/@govbr/dsgov/dist/dsgov.min.css';

function NoticeBoard(props) {

    return(
        <Notice>
                <section className="alert" role="alert" aria-live="polite" aria-label="Quadro de alerta">
                    {props.type === 'alert' &&
                        <>
                            <div className="alert__header">
                                {/* Ícone de alerta (SVG inline) */}
                                <span className="alert__icon" aria-hidden="true">
                                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 8v5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                    <circle cx="12" cy="17" r="1.25" fill="currentColor"/>
                                    <path d="M10.4 3.7 1.9 18.5A2 2 0 0 0 3.6 21h16.8a2 2 0 0 0 1.7-2.5L13.6 3.7a2 2 0 0 0-3.2 0Z" stroke="currentColor" stroke-width="1.8" fill="none"/>
                                    </svg>
                                </span>
                                <span>{props.title}</span>
                            </div>
                            <p className="alert__body" dangerouslySetInnerHTML={{ __html: props.text }} />
                        </>
                    }                
                </section>
        </Notice>
    );
}

export default NoticeBoard;